import statisticsReducers from '../statisticsReducer';

export default statisticsReducers({
    apiDataFieldName: 'avgHeights',
    statisticsActionName: 'AVERAGE_PARCEL_HEIGHTS',
});
